import React from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import RegistrationForm from './components/RegistrationForm';
import TrustSignals from './components/TrustSignals';
import LoginPrompt from './components/LoginPrompt';

const Register = () => {
  return (
    <>
      <Helmet>
        <title>Create Account - Tixful</title>
        <meta name="description" content="Join Tixful to discover and purchase event tickets, or create and manage your own events. Secure registration with role-based access." />
        <meta name="keywords" content="register, sign up, create account, event tickets, event management" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          {/* Logo and Header */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <Icon name="Ticket" size={24} color="white" />
              </div>
              <span className="text-2xl font-bold text-gray-900">Tixful</span>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Create Your Account
            </h1>
            <p className="text-sm text-gray-600">
              Join thousands of users discovering amazing events
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
            <RegistrationForm />
            <div className="mt-8">
              <LoginPrompt />
            </div>
          </div>
        </div>

        {/* Trust Signals - Desktop Only */}
        <div className="hidden lg:block fixed right-8 top-1/2 transform -translate-y-1/2 w-80">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <TrustSignals />
          </div>
        </div>

        {/* Trust Signals - Mobile */}
        <div className="lg:hidden mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-6 px-4 shadow-lg sm:rounded-lg sm:px-10">
            <TrustSignals />
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-12 text-center">
          <div className="text-xs text-gray-500 space-y-2">
            <p>&copy; {new Date()?.getFullYear()} Tixful. All rights reserved.</p>
            <div className="flex justify-center space-x-4">
              <button className="hover:text-gray-700">Terms</button>
              <button className="hover:text-gray-700">Privacy</button>
              <button className="hover:text-gray-700">Support</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Register;